import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { switchTeamsInfo, teamManage } from '../../../actions'
import { formatName } from '../../../helpers'

class TeamsInfo extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showConfirmBttn: {}
    }

    this.dismissPopup = this.dismissPopup.bind(this)
    this.showConfirmBttn = this.showConfirmBttn.bind(this)
  }

  showConfirmBttn (id) {
    let objClone = { ...this.state.showConfirmBttn }
    objClone[id] = true
    this.setState({ showConfirmBttn: objClone })
  }

  dismissPopup () {
    this.props.dispatch(switchTeamsInfo({}))
  }

  render () {
    const { payload, players } = this.props
    const { teams, definition } = payload

    return (
      <div className='dashboard-popup-notif'>
        <div className='hey-popup-header'>
          <h4 className='header-text'>TEAMS {definition}</h4>
          <button
            onClick={this.dismissPopup}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        <div className='pop-message-container '>
          <div className='y-scroll' style={{ position: 'relative' }}>
            {teams && teams.map(t =>
              <div key={t.id}>
                <div className='dashboard-players-row team-title'>
                  <div className='cell-name' style={{ background: `url(${t.avatar || '/imgs/default-avatar.png'}) center center / cover no-repeat` }} />
                  <div className='cell-subject'>
                    <Link className='color-inherit' to={`/team/${t.id}`} target='_blank'><h3>TEAM: {t.name}</h3></Link>
                  </div>
                </div>
                {t.participants && t.participants.map(pId => {
                  let player = players.find(p => p.id === pId)
                  player && (player = player.attending_status === 'invited' ? player : null)
                  if (player) {
                    return (
                      <div className='dashboard-players-row' key={pId}>
                        <div className='cell-name' style={{ background: `url(${player.avatar || '/imgs/default-avatar.png'}) center center / cover no-repeat` }} />
                        <div className='cell-subject'>
                          <Link className='color-inherit' to={`/player/${pId}`} target='_blank'>{formatName(player.name)}</Link>
                        </div>
                        <div className='admin-tab-cell'>
                          {t.owner === pId && <span>onwer</span>}
                          {(t.owner !== pId && !this.state.showConfirmBttn[pId]) &&
                            <button
                              onClick={() => this.showConfirmBttn(pId)}
                              className='button button-sm'>Remove from team</button>
                          }
                          {this.state.showConfirmBttn[pId] &&
                            <button
                              onClick={() => this.props.dispatch(teamManage({ admin: true, participants: t.participants.filter(plId => plId !== pId) }))}
                              className='button button-sm'>Confirm</button>
                          }
                        </div>
                      </div>
                    )
                  } else { return (<span key={pId} />) }
                })}
              </div>
            )}
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    payload: state.popup.payload,
    players: state.participants,
    teams: state.team.teams
  }
}

export default connect(mapStateToProps)(TeamsInfo)



// WEBPACK FOOTER //
// ./src/components/common/popups/TeamsInfo.js